/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyEthereum = createReactComponent(
  "currency-ethereum",
  "IconCurrencyEthereum",
  [
    ["path", { d: "M6 12l6 -9l6 9l-6 9z", key: "svg-0" }],
    ["path", { d: "M6 12l6 -3l6 3l-6 2z", key: "svg-1" }]
  ]
);

export { IconCurrencyEthereum as default };
//# sourceMappingURL=IconCurrencyEthereum.js.map
